import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ImportMismoIntoLoanModalTestIds } from '../../ImportMismoIntoLoanModal.testIds';

import {
  getSidebarItemStyles,
  sidebarItemCountStyles,
  sidebarItemLabelStyles,
  sidebarStyles,
} from './MismoChangeSidebar.styles';

const MismoChangeSidebar = ({ sections, selectedIndex, onSelect }) => {
  const onItemSelect = useCallback(
    event => onSelect(Number(event.currentTarget.dataset.index)),
    [onSelect],
  );

  return (
    <Box data-testid={ImportMismoIntoLoanModalTestIds.SIDEBAR} sx={sidebarStyles}>
      {sections.map((section, index) => (
        <Box
          data-index={index}
          data-testid={ImportMismoIntoLoanModalTestIds.SIDEBAR_ITEM}
          key={section.section}
          sx={getSidebarItemStyles(index === selectedIndex)}
          onClick={onItemSelect}
        >
          <Typography sx={sidebarItemLabelStyles} variant="regular14">
            {section.section}
          </Typography>
          <Typography sx={sidebarItemCountStyles} variant="regular12">
            {section.changes.length}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

MismoChangeSidebar.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string,
      changes: PropTypes.array,
    }),
  ).isRequired,
  selectedIndex: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default memo(MismoChangeSidebar);
